import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { tap, map } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { TokenStorage } from '../services/token.service';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = inject(TokenStorage);
  const cookieService = inject(CookieService);
  return authService.isAuthenticated().pipe(
    tap(isAuth => {
      if (!isAuth) {
        if (cookieService.check('JWTtoken')) {
        // if (cookieService.check('Uad-Token')) {
          token.save(token.getJWTtoken());
          token.saveRT(token.getRefreshToken());
          return true;
        }
        // Store the attempted URL for redirecting
        authService.redirectUrl = state.url;

        // Navigate to the login page
        const redirectUrl = '/auth/access';
        window.location.href = redirectUrl;
        router.navigate([redirectUrl]);

      }
      return true;
    }),
    map(isAuth => isAuth)
  );
};
